import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59e84d8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-list" }
const _hoisted_2 = { class: "sync-table" }
const _hoisted_3 = { class: "flex-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"200px","font-size":"14px"} }, " Amazonセラーセントラルで「梱包の担当者」または「ラベルの担当者」が未設定のため、当システムでは「出品者」に自動設定しました。このままでも納品プランの作成は可能です。必要に応じて、Amazonセラーセントラルで設定を変更し、商品を再同期してください。 ", -1))
const _hoisted_5 = { class: "flex-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"200px","font-size":"14px"} }, " Amazonセラーセントラルで「梱包の担当者」または「ラベルの担当者」が未設定のため、当システムでは「出品者」に自動設定しました。このままでも納品プランの作成は可能です。必要に応じて、Amazonセラーセントラルで設定を変更し、商品を再同期してください。 ", -1))

import { t } from '@/plugins/i18n'
import { ref, reactive, computed, nextTick, toRaw } from 'vue'
import STable from '@/components/Table/index.vue'
import SSearch from './Search.vue'
import { setNoEmptyForm } from '@/util/common'
import { ElMessage } from 'element-plus'
import { QuestionFilled } from '@element-plus/icons-vue'
import { useStore } from 'vuex'
import { delProduct, amazonPage } from '@/apis/order'
import { updateAmazonProductApi } from '@/apis/goods'
import { getPrepCategoryListApi } from '@/apis/stock'
import { syncAllGoods } from '@/apis/associated'
import { confirmApiUnbind } from '@/util/useConfirm'
import { useRequest } from '@/util/useLoading'
import { isJA } from '@/store'
import BatchSearch from '@/components/BatchSearch/index.vue'
import AmazonTip from './AmazonTip.vue'
import bus from '@/util/useBus'
import { labelMap } from './data'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tableConfig = {
  showHandler: true,
  setHeight: true,
  handlerConfig: { label: ' ' }
}
const updateLoading = ref(false)
const columns = computed(() => {
  const col = [
    {
      label: t('商品信息'),
      prop: 'shopOrderInfo',
      slotName: 'shopOrderInfo',
      width: 400
    },
    {
      label: t('Amazon sku'),
      prop: 'amazonMsku',
      align: 'center'
    },
    {
      label: t('fnsku'),
      prop: 'amazonFnsku',
      align: 'center'
    },
    {
      label: t('asin'),
      prop: 'amazonAsin',
      align: 'center'
    }
  ]
  const jaCol = [
    {
      label: t('预处理分类'),
      prop: 'prepCategory',
      align: 'center',
      slotName: 'prepCategory',
      width: 130

    },
    {
      // label: t('预处理方'),
      prop: 'prepOwner',
      align: 'center',
      slotName: 'prepOwner',
      slotHeadName: 'prepOwnerHead',
      width: 150
    },
    {
      // label: t('贴标方'),
      prop: 'labelOwner',
      align: 'center',
      slotName: 'labelOwner',
      slotHeadName: 'labelOwnerHead',
      width: 180
    },
    {
      label: t('商品状态'),
      prop: 'isValid',
      align: 'center',
      slotName: 'isValid'
    }
  ]
  return [...col, ...(isJA() ? jaCol : [])]
})
const [syncLoading, syncApi] = useRequest(syncAllGoods)
const setSyncProduct = async () => {
  const unbind = await confirmApiUnbind()
  if (unbind) return
  syncApi().then((res: any) => {
    if (res.success) {
      ElMessage.success(t('同步商品进行中，请等待1-3分钟'))
      setTimeout(() => refreshTable(true), 1000)
    }
  })
}

const delOrder = (row: any) => {
  row.delLoading = true
  delProduct({ amazonMsku: row.amazonMsku }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('修改成功'))
      refreshTable()
    }
  }).finally(() => { row.delLoading = false })
}

const STableRef = ref()
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}
const searchForm: any = ref({})

const store = useStore()
const customerShopId = store.getters.curShop

const filterData = computed(() => {
  const data = { ...toRaw(searchForm.value) }
  data.amazonMskuList = data.amazonMskuList ? [data.amazonMskuList] : undefined
  return {
    customerShopId,
    ...setNoEmptyForm({
      ...data
    })
  }
})

const pageData = ref({
  page: 1,
  limit: 30
})

const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearch', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = {
    ...params,
    customerShopId
  }
  refreshTable(true)
})
const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
}
const updateGoods = async (row:{amazonMsku:string, updateLoading?:boolean}) => {
  if (updateLoading.value || row.updateLoading) return
  updateLoading.value = true
  row.updateLoading = true
  const { success } = await updateAmazonProductApi({
    amazonMsku: row.amazonMsku
  })
  if (success) {
    ElMessage.success(t('更新成功'))
    refreshTable()
  }
  row.updateLoading = false
  await new Promise((resolve) => setTimeout(resolve, 3000))
  updateLoading.value = false
}

const prepCategoryList:any = ref([])
const getCategoryList = () => {
  getPrepCategoryListApi().then((res) => {
    prepCategoryList.value = res.data ?? []
  })
}
getCategoryList()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AmazonTip, {
      title: _unref(t)('根据Amazon的规定，建发货时需要建立好预处理分类、预处理方和贴标方，请及时去Amazon后台更新信息，并重新更新商品'),
      keyValue: "AmazonProductTip"
    }, null, 8, ["title"]),
    _createVNode(SSearch, {
      form: searchForm.value,
      "onUpdate:form": [
        _cache[0] || (_cache[0] = ($event: any) => ((searchForm).value = $event)),
        search
      ],
      prepCategoryList: prepCategoryList.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            style: {"margin-left":"6px"},
            type: "primary",
            loading: _unref(syncLoading),
            onClick: setSyncProduct
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('同步商品')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["form", "prepCategoryList"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(STable, {
        ref: (_value, _refs) => {
          _refs['STableRef'] = _value
          STableRef.value = _value
        },
        "page-data": pageData.value,
        "onUpdate:page-data": _cache[1] || (_cache[1] = ($event: any) => ((pageData).value = $event)),
        api: _unref(amazonPage),
        filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
        columns: _unref(columns),
        "table-config": tableConfig
      }, {
        prepOwnerHead: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_unref(t)('预处理方')) + " ", 1),
            _createVNode(_component_el_tooltip, {
              placement: "top",
              effect: "light",
              "popper-class": "tool-tip-no-border"
            }, {
              content: _withCtx(() => [
                _hoisted_4
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  color: "#999",
                  class: "cursor-pt",
                  style: {"margin-left":"6px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(QuestionFilled))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        labelOwnerHead: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_unref(t)('贴标方')) + " ", 1),
            _createVNode(_component_el_tooltip, {
              placement: "top",
              effect: "light",
              "popper-class": "tool-tip-no-border"
            }, {
              content: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  color: "#999",
                  class: "cursor-pt",
                  style: {"margin-left":"6px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(QuestionFilled))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        shopOrderInfo: _withCtx(({ row }) => [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(row.productName ?? '') + "/", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productProp || '').split(';'), (prop) => {
              return (_openBlock(), _createElementBlock("span", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
            }), 128))
          ])
        ]),
        handler: _withCtx(({ scope }) => [
          _createVNode(_component_el_popconfirm, {
            "popper-class": "pay-pop",
            title: _unref(t)('是否删除'),
            onConfirm: ($event: any) => (delOrder(scope.row))
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_table_button, {
                title: _unref(t)('删除'),
                loading: scope.row.delLoading
              }, null, 8, ["title", "loading"])
            ]),
            _: 2
          }, 1032, ["title", "onConfirm"]),
          (_unref(isJA)())
            ? (_openBlock(), _createBlock(_component_table_button, {
                key: 0,
                title: _unref(t)('更新'),
                loading: scope.row.updateLoading,
                onClick: ($event: any) => (updateGoods(scope.row))
              }, null, 8, ["title", "loading", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        prepOwner: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_unref(labelMap)[row.prepOwnerConstraint] ?? '-'), 1)
        ]),
        labelOwner: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_unref(labelMap)[row.labelOwnerConstraint] ?? '-'), 1)
        ]),
        isValid: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(['', _unref(t)('有效'), _unref(t)('失效2')][row.isValid] ?? '-'), 1)
        ]),
        prepCategory: _withCtx(({row}) => [
          _createTextVNode(_toDisplayString(prepCategoryList.value.find(v => v.value === row.prepCategory)?.descJa ?? '-'), 1)
        ]),
        _: 1
      }, 8, ["page-data", "api", "filterData", "columns"])
    ]),
    _createVNode(BatchSearch)
  ]))
}
}

})